import React from 'react';
import classNames from 'classnames';
import SubsidiaryAppLogo from 'components/SubsidiaryAppLogo/SubsidiaryAppLogo';
import { useCookieBannerState } from 'common/hooks/useCookieBannerState';
import LanguageMenu from 'components/LanguageMenu/LanguageMenu';
import CookieInfo from 'components/common/CookieInfo/CookieInfo';
import styles from './PageTemplate.module.scss';

export type PageTemplateProps = {
  children?: React.ReactNode;
  showLanguageMenu?: boolean;
  dataTestId?: string;
};

const PageTemplate = ({ children, showLanguageMenu, dataTestId }: PageTemplateProps) => {
  const { cookieBannerVisible } = useCookieBannerState();

  return (
    <div className={styles.changePasswordWrapper}>
      <main id={dataTestId} className={styles.changePasswordContent}>
        <SubsidiaryAppLogo />
        {children}
      </main>
      {showLanguageMenu && (
        <footer id="footer" className={classNames(styles.footer, cookieBannerVisible && styles.extraFooter)}>
          <LanguageMenu />
        </footer>
      )}
      <CookieInfo />
    </div>
  );
};

PageTemplate.defaultProps = {
  showLanguageMenu: true,
  dataTestId: undefined,
};
export default PageTemplate;
